<template>
  <v-navigation-drawer v-model="shown"
                       @input="$emit('input', $event)"
                       app
                       disable-resize-watcher>
    <v-list nav class="text-left mobile-nav-list">
      <v-list-item link
                   exact
                   :to="{name: 'Home'}"
                   class="single-level">
        <v-list-item-content>
          <v-list-item-title>{{ $t('header.home') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link
                   exact
                   :to="{name: 'Register'}"
                   class="single-level">
        <v-list-item-content>
          <v-list-item-title>{{ $t('header.register') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="$i18n.locale !== 'zh'"
                   @click="changeLocale('zh')"
                   class="single-level">
        <v-list-item-content>
          <v-list-item-title>中</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="$i18n.locale !== 'en'"
                   @click="changeLocale('en')"
                   class="single-level">
        <v-list-item-content>
          <v-list-item-title>EN</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {ref, watch} from '@vue/composition-api'

export default {
  name: 'MobileNavigationDrawer',
  props: {
    value: Boolean,
  },
  setup(props, {root}) {
    const shown = ref(false);
    watch(() => props.value, (newValue) => shown.value = newValue);

    const changeLocale = function (locale) {
      root.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
      window.location.reload();
    }

    return {
      shown,
      changeLocale,
    }
  },
}
</script>
